import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

export default function AmploSteps(props) {
  const { currentStep, stepCount, ...rest } = props;
  const range = Array.from({ length: stepCount }, (_, i) => i);

  const styles = {
    root: {
      height: '9px',
      backgroundColor: '#dfe2e1',
    },
    filled: {
      backgroundColor: (theme) => theme.palette.secondary.main,
    },
    container: {
      width: '100%',
      borderRadius: '4px',
      overflow: 'hidden',
      
    },
  };

  return (
    <Grid container sx={styles.container} {...rest}>
      {range.map((_, i) => (
        <Grid size={stepCount} key={i} item xs sx={{
              ...styles.root,
              ...(i <= currentStep ? styles.filled : {}),
            }}>
        </Grid>
      ))}
    </Grid>
  );
}

AmploSteps.propTypes = {
  currentStep: PropTypes.number,
  stepCount: PropTypes.number,
};
